
import {
  IconCalendarWithCheck,
  IconClock,
  IconTruck,
  RevModal,
} from '@backmarket/design-system'

import { MODAL_NAMES } from '@config/constants'

import ContentRow from '../../ContentRow'

import translations from './ShippingModal.translations'

export default {
  components: {
    RevModal,
    ContentRow,
  },
  computed: {
    translations: () => translations,
    modalName: () => MODAL_NAMES.PRODUCT.EXPRESS_SHIPPING,

    icons() {
      return {
        IconClock,
        IconCalendarWithCheck,
        IconTruck,
      }
    },
  },
}
